import authBaseHttpRequest from './authBaseHttpRequest';
import {
  mockConfigResponse,
  mockCalculateResponse,
  getDefaultTogglesForPhase,
} from './calculatorMock';

const USE_MOCK = process.env.REACT_APP_USE_CALCULATOR_MOCK === 'true';

/**
 * Load calculator configuration.
 * GET /api/calculator/config
 * @returns {Promise<{ response?: object, error?: object }>}
 */
export const getCalculatorConfig = () => {
  if (USE_MOCK) {
    return Promise.resolve({ response: mockConfigResponse });
  }
  return authBaseHttpRequest({
    method: 'get',
    url: '/api/calculator/config',
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => {
      // Fallback to mock on network/API error so app remains usable
      if (error?.response?.status === 404 || error?.message?.includes('Network')) {
        return { response: mockConfigResponse };
      }
      return { error: error.response || error };
    });
};

/**
 * Calculate ROI results.
 * POST /api/calculator/calculate
 * @param {object} payload - { employees, phase, selectedIncentives: { [id]: { enabled, coins } } }
 * @returns {Promise<{ response?: object, error?: object }>}
 */
export const calculateResults = (payload) => {
  if (USE_MOCK) {
    return Promise.resolve({
      response: {
        ...mockCalculateResponse,
        productivitySavings: payload?.selectedIncentives?.productivity?.enabled ? 2100 : 0,
      },
    });
  }
  return authBaseHttpRequest({
    method: 'post',
    url: '/api/calculator/calculate',
    headers: { 'Content-Type': 'application/json' },
    data: payload,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => {
      if (error?.response?.status === 404 || error?.message?.includes('Network')) {
        return {
          response: {
            ...mockCalculateResponse,
            productivitySavings: payload?.selectedIncentives?.productivity?.enabled ? 2100 : 0,
          },
        };
      }
      return { error: error.response || error };
    });
};

export { getDefaultTogglesForPhase };
